export interface DashboardMetadata {
    callback?: Function;
    methodName: string;
    name: string;
}
